import useParams from '@src/Hooks/useParams';
import useDefaultPaywall from '@src/Store/selectors/useDefaultPaywall';
import useMember from '@src/Store/selectors/useMember';
import useBreakpoint from 'design-system/src/WebComponent/Grid/hooks/useBreakpoint';
import PaywallSectionPage from '@src/Umbraco/Pages/PaywallSectionPage/PaywallSectionPage';
import React from 'react';
import {View} from 'react-native';
import {UmbTypeChecker} from '@src/Umbraco/Utils/UmbTypeChecker';

type WithId = {
  id: string;
};

const ChoosePlanPage = () => {
  const member = useMember();
  const params = useParams();
  const {isMobile} = useBreakpoint();

  const defaultPaywall = useDefaultPaywall();
  const {paywall, trackingData} = params || {};
  const paywallId = UmbTypeChecker.isPaywall(paywall)
    ? (paywall as unknown as WithId).id
    : defaultPaywall?.id;

  return member ? (
    <View
      style={{
        flex: 1,
        height: '100%',
        width: '100%',
        position: 'relative',
        overflow: 'hidden',
      }}>
      <PaywallSectionPage
        variant="choosePlan"
        id={paywallId}
        orientation={isMobile ? 'portrait' : 'landscape'}
        trackingData={trackingData || {}}
      />
    </View>
  ) : (
    <div>No member found</div>
  );
};

export default ChoosePlanPage;
